"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceExtensions = void 0;
const tsyringe_1 = require("tsyringe");
const globalSymbols_1 = require("./globalSymbols");
const DefaultThemeManager_1 = require("./core/render/theme/DefaultThemeManager");
const ThemeManagerStartupItem_1 = require("./core/render/theme/ThemeManagerStartupItem");
class ServiceExtensions {
    constructor(application) {
        this.application = application;
    }
    addThemeManager() {
        tsyringe_1.container.registerSingleton(globalSymbols_1.TThemeManager, DefaultThemeManager_1.DefaultThemeManager);
        tsyringe_1.container.registerType(globalSymbols_1.TStartupItem, ThemeManagerStartupItem_1.ThemeManagerStartupItem);
        return this;
    }
    addPlugin(plugin) {
        tsyringe_1.container.registerInstance(globalSymbols_1.TPlugins, plugin);
        return this;
    }
}
exports.ServiceExtensions = ServiceExtensions;
//# sourceMappingURL=serviceExtensions.js.map